module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_17_I_2.80ab67c2.mp3";